import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-de',
  templateUrl: './privacy-policy-de.component.html',
  styleUrls: ['./privacy-policy-de.component.scss']
})
export class PrivacyPolicyDeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
